// Single source of truth for the project lifecycle status, so the badge color and the editable
// dropdown never drift apart (the list card, the project header, and the edit form all read it).
//
// Values are camelCase to match the backend ProjectStatus enum as serialized by the global
// camelCase JSON converter. The lifecycle splits into two groups: live states (the search can
// still happen or is happening) and terminal states (the project's lifecycle has ended). Only
// "active" counts toward the plan's active-project usage on the backend.
export const LIVE_PROJECT_STATUSES = ["potential", "active", "onHold"];
export const TERMINAL_PROJECT_STATUSES = ["neverStarted", "completed", "closed"];
export const PROJECT_STATUSES = [...LIVE_PROJECT_STATUSES, ...TERMINAL_PROJECT_STATUSES];

const STATUS_COLORS = {
  potential: "gray",     // not yet pitched
  active: "blue",        // search running
  onHold: "yellow",      // paused by the client
  neverStarted: "dark",  // pitched but never commissioned
  completed: "green",    // role filled / won
  closed: "red",         // terminated mid-search — cancelled / lost
};

export const projectStatusColor = (status) => STATUS_COLORS[status] ?? "gray";

// i18n-resolved label; falls back to the raw value for any unexpected status.
export const projectStatusLabel = (t, status) =>
  t(`project_status_${status}`, { defaultValue: status ?? "" });

// Grouped for Mantine Select, so six options read as two small sets instead of clutter.
export const projectStatusOptions = (t) => [
  {
    group: t("project_status_group_live"),
    items: LIVE_PROJECT_STATUSES.map((s) => ({ value: s, label: projectStatusLabel(t, s) })),
  },
  {
    group: t("project_status_group_terminal"),
    items: TERMINAL_PROJECT_STATUSES.map((s) => ({ value: s, label: projectStatusLabel(t, s) })),
  },
];
